module.exports = __webpack_public_path__ + "img/charity.20617b37.png";